<template>
  <div>
    <v-row class="mx-0 mb-3" justify="space-between">
      <h3 class="title white--text">Email Delivery</h3>
    </v-row>

    <v-card>
      <v-tabs v-model="tab" :grow="true">
        <v-tab>Queue</v-tab>
        <v-tab>History</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <EmailDeliveryQueueView />
        </v-tab-item>
        <v-tab-item>
          <EmailDeliveryHistoryView />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { EmailDeliveryQueueView, EmailDeliveryHistoryView } from "@/modules/admin.email_delivery";
export default {
  data() {
    return {
      tab: null,
    };
  },
  components: {
    EmailDeliveryQueueView,
    EmailDeliveryHistoryView,
  },
  methods: {},
  mounted() {},
};
</script>
